import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { ElPeriodo, Periodo } from '@/lib/supabase/tipos-bd'

/**
 * Las cifras del periodo que se escoja: semana, mes o año (fn_el_periodo,
 * 0244). Se pide con cualquier fecha de adentro; la base devuelve sus bordes
 * y hace todas las cuentas con la hora de Cartago.
 *
 * El que va en curso se refresca cada cinco minutos, como el resto del
 * tablero; los que ya terminaron no cambian.
 */
export function useElPeriodo(periodo: Periodo, fecha: string, enCurso: boolean) {
  return useQuery({
    queryKey: ['el-periodo', periodo, fecha],
    queryFn: async (): Promise<ElPeriodo> => {
      const { data, error } = await supabase.rpc('fn_el_periodo', {
        p_periodo: periodo,
        p_fecha: fecha,
      })
      if (error) throw new Error(mensajeDeError(error))
      return data as ElPeriodo
    },
    refetchInterval: enCurso ? 5 * 60_000 : false,
    staleTime: enCurso ? 60_000 : Infinity,
    // Al cambiar de periodo se sigue viendo el anterior mientras llega el
    // nuevo, en vez de un parpadeo en blanco.
    placeholderData: (previo) => previo,
  })
}
